import React from 'react';
import InsuranceList from 'subscriptions/SubscriptionList/insurance';
import Box from 'common/Box';

const InsuranceEligibilityScreen = () => (
  <div>
    <h1>Device Protection Eligibility</h1>
    <Box>
      <h3>
        Which device on your account would you like to add Device Protection to? 
      </h3>
      <p>
        Our protection plan protects your device from accidental damage, broken screens and mechanical malfunction.
      </p>
    </Box>
    <InsuranceList />
  </div>
);

export default InsuranceEligibilityScreen;
